// extracted by mini-css-extract-plugin
export default {"accordionHeaderImage":"Accordion_accordionHeaderImage__-r98s"};